import Send from "./requests";

// export const link = process.env.REACT_APP_BACKEND_URL;
const link = 'https://api.vspay.cloud/mapa-rede/V1/CLIENTE/'
//----------------get--------------

export const methodGET = async (url) => {
  const request = {
    url: link + url,
    method: "GET",
    timeout: 1000 * 5, //espera 5 segundos, não retornando da erro
  };
  try {
    const { status, data } = await Send(request);
      return {status, data};
  } catch (error) {
    return {status: 0, data: []};
  }
};
